export default {
	"39a8c193b3b84def79a278b709e94f2b": "The unionId was not obtained",
	"ac70c15430eff1f21a7baaa5e188ca9e": "\"Jumping...\"",
	"0675de48149f684874f7629cace17ff8": "The request failed. Please contact customer service"
}
